import { DAILYUPDATE_ADD, DAILYUPDATE_LIST } from "./ActionType"

const initialValue={
    createDailyUpdate:null,
    dailyUpdateDetails: [],
    }

export const dailyUpdateReducer=(store=initialValue, {type,payload})=>{

    if(type===DAILYUPDATE_ADD){
       return {...store,createDailyUpdate:payload}
   }
   else if(type===DAILYUPDATE_LIST){
    return {
        ...store,
        dailyUpdateDetails: payload || [], 
    };
   }
  
   
   return store
}